import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import InventoryQuote from 'components/QuickTrade/InventoryQuote';
import OrderDepth from 'components/OrderDepth';

import * as UserUtils from 'utils/user';
import * as CustomerUtils from 'utils/customer';

class SecurityDigest extends React.Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
  };

  render() {
    const { user } = this.props;
    const { ITEM, SECTOR } = this.props.item;
    const customer = UserUtils.getCustomerData(user);
    const selectedAccount = CustomerUtils.getSelectedAccount(customer);
    const portfolioId = selectedAccount.get('customerId');
    const userId = selectedAccount.get('customerNumber');
    const itemSector = `${ITEM}.${SECTOR}`;

    return (
      <div className="SecurityDigest">
        <InventoryQuote
          {...this.props}
          portfolioId={portfolioId}
          userId={userId}
        />
        <OrderDepth itemSector={itemSector} levels={2} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { user: state.user };
}

export default connect(mapStateToProps)(SecurityDigest);
